<template>
  <div class="text-input-comp">    
    <div class="label outside">{{label}}</div>
    <text-with-units v-model="internal_value" v-bind="$props"></text-with-units>
  </div>
</template>

<script>
import TextWithUnits from '@/components/inputs/TextWithUnits'
export default {
  components: {TextWithUnits},
  model:{
    prop: 'value',
    event: 'change'
  },
  computed: {
    internal_value:{
      get(){
        return this.value
      },
      set(val){
        this.$emit('change',val)
      }
    }
  },
  props:['value','label','unit','min','max'],
}
</script>

<style lang="stylus" scoped>
.text-input-comp
  .label
    color: $shuttle-gray
    m-font-size(12, 14)
    text-transform: capitalize

    &.inside
      margin-right: 5px
      white-space: nowrap

    &.outside
      margin-bottom: 5px

      &.side
        margin-bottom: 0
        margin-right: 10px
  >>> input
    border: 1px solid #fff
    border-radius: 4px
    // box-shadow: 5px 5px 20px rgba($lynch, 0.25)
    // color: rgba($cloud-burst, 0.5)
    color: $cloud-burst //no?
    m-font-size(13, 16)
    min-height: 32px
    padding: 0 10px
    border-color: $mystic

    &:hover
      border-color: $heather

    &:focus
      border-color: $cloud-burst
      color: $cloud-burst
      outline: none
</style>